import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="carrier-form"
// Toggles visibility of carrier form fields based on the selected data source.
export default class extends Controller {
  static targets = ["trackingUrl", "shippoToken", "otherToken"]

  connect() {
    this.updateFieldVisibility()
  }

  updateFieldVisibility() {
    const select = this.element.querySelector("#carrier_data_source")
    if (!select) return

    const value = select.value

    const showTracking = value === "shippo" || value === "marken" || value === "other"
    const showShippo = value === "shippo"
    const showOther = value === "other"

    this.trackingUrlTarget.style.display = showTracking ? "" : "none"
    this.shippoTokenTarget.style.display = showShippo ? "" : "none"
    this.otherTokenTarget.style.display = showOther ? "" : "none"
  }
}
